import fetch from 'isomorphic-fetch'
import {browserHistory} from 'react-router'
import {pendingTask, begin, end} from 'react-redux-spinner'
import {
  GET_VENUE_REQUEST,
  GET_VENUE,
  GET_VENUE_ERROR,
  UPDATE_VENUE_REQUEST,
  UPDATE_VENUE,
  UPDATE_VENUE_ERROR,
} from './types'

export function getVenueRequest() {
  console.log('get venue request')
  const data = {
    loading: true,
  }
  return {
    type: GET_VENUE_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function getVenueSuccess(venue) {
  console.log('venue: ' + JSON.stringify(venue))
  const data = {
    loading: false,
    venue,
  }
  return {
    type: GET_VENUE,
    [pendingTask]: end,
    payload: data,
  }
}

export function getVenueFail(error) {
  const data = {
    loading: false,
    error,
  }
  return {
    type: GET_VENUE_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export function getVenue(id) {
  //console.log('GET A VENUE WITH ID: ' +id);
  return dispatch => {
    dispatch(getVenueRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/venue/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
    })
      .then(res => res.json())
      .then(json => {
        //console.error('getVenue: ' + JSON.stringify(json.venue))
        dispatch(getVenueSuccess(json.venue))
      })
      .catch(error => dispatch(getVenueFail(error)))
  }
}

export function updateVenueRequest() {
  return {
    type: UPDATE_VENUE_REQUEST,
    [pendingTask]: begin,
    payload: {fetching: true},
  }
}

export function updateVenueSuccess(venue) {
  return {
    type: UPDATE_VENUE,
    [pendingTask]: end,
    payload: venue,
  }
}

export function updateVenueFail(error) {
  return {
    type: UPDATE_VENUE_ERROR,
    [pendingTask]: end,
    payload: {error: error},
  }
}

export function updateVenue(venue) {
  //console.log('UPDATING VENUE')
  return dispatch => {
    dispatch(updateVenueRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/venue/${venue.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
      body: JSON.stringify(venue),
    })
      .then(res => res.json())
      .then(json => {
        dispatch(updateVenueSuccess(json.venue))
        browserHistory.push(`/venues/${venue.id}`)
      })
      .catch(error => dispatch(updateVenueFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/venue_edit.js
 **/